import React, { useState } from 'react';
import classnames from 'classnames';
import { NotecardEditorSelectFont } from '../notecard-editor-select-font';
import { NOTECARD_EDITOR_SELECT_TYPES } from '../constants';
import { NotecardEditorSelectTextProperty } from '../notecard-editor-select-text-property';
import { NotecardEditorSelectFontSize } from '../notecard-editor-select-font-size';
import { NotecardEditorSelectAlignment } from '../notecard-editor-select-alignment';
import { NotecardEditorSelectColor } from '../notecard-editor-select-color';
import classes from './notecard-editor-panel.scss';
export const NotecardEditorPanel = ({
  selectionStyles,
  textAlignment,
  containerClassName,
  handleSelectStyleChange,
  changeEditorBlockDataBySelection,
  restoreEditorSelection
}) => {
  const [openedTab, setOpenedTab] = useState(null);
  const toggleOpened = value => {
    const newValue = openedTab === value ? null : value;
    setOpenedTab(newValue);
  };
  const getProps = selectType => ({
    selectionStyles,
    handleSelectStyleChange,
    isOpened: openedTab === selectType,
    toggleOpened: () => toggleOpened(selectType)
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper,
    onFocus: restoreEditorSelection,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.container, containerClassName)
  }, /*#__PURE__*/React.createElement(NotecardEditorSelectFont, getProps(NOTECARD_EDITOR_SELECT_TYPES.FONT)), /*#__PURE__*/React.createElement(NotecardEditorSelectTextProperty, getProps(NOTECARD_EDITOR_SELECT_TYPES.TEXT_PROPERTY)), /*#__PURE__*/React.createElement(NotecardEditorSelectFontSize, getProps(NOTECARD_EDITOR_SELECT_TYPES.FONT_SIZE)), /*#__PURE__*/React.createElement(NotecardEditorSelectAlignment, {
    textAlignment: textAlignment,
    changeEditorBlockDataBySelection: changeEditorBlockDataBySelection,
    isOpened: openedTab === NOTECARD_EDITOR_SELECT_TYPES.TEXT_ALIGN,
    toggleOpened: () => toggleOpened(NOTECARD_EDITOR_SELECT_TYPES.TEXT_ALIGN)
  }), /*#__PURE__*/React.createElement(NotecardEditorSelectColor, getProps(NOTECARD_EDITOR_SELECT_TYPES.COLOR))));
};